import { createFileRoute } from "@tanstack/react-router"
import { PolicyDetailPage } from "@/components/rema/policies"

function PolicyDetailRoute() {
  const { policyNumber } = Route.useParams()
  return (
    <div className="p-6">
      <PolicyDetailPage policyNumber={policyNumber} />
    </div>
  )
}

export const Route = createFileRoute("/rema/policies/$policyNumber")({
  staticData: {
    title: 'Policy Detail',
    isSecured: true,
  },
  component: PolicyDetailRoute,
})
